import React from 'react';
import {
  Box,
  TextField,
  IconButton,
  // Typography
} from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
// import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';

interface ChatInputProps {
  value: string;
  onChange: (value: string) => void;
  onSubmit: (e: React.FormEvent) => void;
}

export const ChatInput: React.FC<ChatInputProps> = ({
  value,
  onChange,
  onSubmit,
}) => (
  <Box
    sx={{
      borderTop: '1px solid #e5e7eb',
      px: 3,
      py: 2,
      display: 'flex',
      flexDirection: 'column',
      gap: 1.5,
    }}
  >
    <Box component="form" onSubmit={onSubmit} sx={{ position: 'relative' }}>
      <TextField
        fullWidth
        placeholder="Ask me anything about AI CoE..."
        value={value}
        onChange={e => onChange(e.target.value)}
        sx={{
          '& .MuiOutlinedInput-root': {
            pr: 6,
            py: 1.5,
            fontSize: '16px',
            borderColor: '#d1d5db',
            '& fieldset': { borderColor: '#d1d5db' },
            '&:hover fieldset': { borderColor: '#9ca3af' },
            '&.Mui-focused fieldset': {
              borderColor: '#9ca3af',
              borderWidth: '1px',
            },
          },
        }}
      />
      <IconButton
        type="submit"
        sx={{
          position: 'absolute',
          right: 8,
          top: '50%',
          transform: 'translateY(-50%)',
          width: 32,
          height: 32,
          bgcolor: 'black',
          '&:hover': { bgcolor: '#1f2937' },
          color: 'white',
        }}
      >
        <ArrowForwardIcon sx={{ fontSize: 16 }} />
      </IconButton>
    </Box>
    {/* <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <AutoAwesomeIcon sx={{ fontSize: 14, color: '#6b7280' }} />
      <Typography sx={{ fontSize: '12px', color: '#6b7280' }}>Deep thinking</Typography>
    </Box> */}
  </Box>
);
